import { ArrowBackIcon } from '@medeloop/medeloop-components-library';
import { Link } from 'react-router-dom';

interface NavigateBackProps {
  readonly to: string;
  readonly label: string;
}

export function NavigateBack({ to, label }: NavigateBackProps) {
  return (
    <div className="py-4 text-content-on-dark-default text-sm">
      <Link to={to} className="flex items-center gap-2">
        <ArrowBackIcon className="h-5 w-5" /> {label}
      </Link>
    </div>
  );
}
